export class InvalidActionException extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'InvalidActionException';
  }
}
